import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    token: string = '';

    tokenIsValid = false;
    userToken: Subject<boolean> = new Subject<boolean>();

    constructor() {
        this.userToken.subscribe((value) => {
            this.tokenIsValid = value;
        });
    }

    private readonly url_api = 'https://svc.ecommerce-mobility-es.pf.dev.echonet/api/mobility/';

    setIsValid(value: boolean) {
        this.tokenIsValid = value;
    }

    getIsValid() {
        return true;
        //return this.tokenIsValid;//-OJO-http://localhost:8080/access/DVDFFFF->URL para pasar el token a mi app
    }

    changeTokenIsValid(tokenIsValid: boolean) {
        this.userToken.next(tokenIsValid);
    }
}
